import React, { Fragment, ReactNode } from 'react'
import { Box, Flex } from '../box'
import { SpaceProps, SystemProps } from '../../theme'

interface Props extends Omit<SystemProps, 'flexDirection'> {
  children: ReactNode
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
  separator?: ReactNode
  spacing?: SpaceProps['h']
}

export const Stack = ({
  children,
  direction = 'column',
  separator,
  spacing = 4,
  ...props
}: Props) => {
  const isHorizontal = direction.includes('row')

  const spaceBox = spacing ? (
    <Box
      w={isHorizontal ? spacing : undefined}
      h={!isHorizontal ? spacing : undefined}
      flexShrink={0}
    />
  ) : null
  const separatorBox = (
    <>
      {spaceBox}
      {separator && (
        <>
          {separator}
          {spaceBox}
        </>
      )}
    </>
  )

  return (
    <Flex {...props} flexDirection={direction}>
      {React.Children.toArray(children).map((child, index) => (
        <Fragment key={index}>
          {index !== 0 && separatorBox}
          {child}
        </Fragment>
      ))}
    </Flex>
  )
}
